import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./index.css";
import { useRef, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./components/LoginPage";
import Navbar from "./components/Navbar";
import DashboardPage from "./components/DashboardPage";
import AddUrlComponent from "./components/AddUrlComponent";
import ProductListBC from "./components/ProductListBC";
import AnalyticsDashboard from "./components/analytics/AnalyticsDashboard";
import UsersPage from "./components/UsersPage";
import RetailersPage from "./components/RetailersPage";
import ReportsPage from "./components/ReportsPage";

function PageTitle({ title }) {
  const location = useLocation();
  useEffect(() => {
    document.title = title ? `Scan Loom | ${title}` : "Scan Loom";
  }, [title, location]);
  return null;
}

function PrivateRoute({ children }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="app-bg d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}><div className="spinner-border text-white" /></div>;
  return user ? children : <Navigate to="/login" />;
}

function Layout({ children, title }) {
  return (
    <div className="app-bg">
      <PageTitle title={title} />
      <Navbar />
      <div className="tl-content">{children}</div>
    </div>
  );
}

function ProductsPage() {
  const { user } = useAuth();
  const canCreate = user?.role === "admin" || user?.role === "creator";
  const viewRef = useRef();

  const handleProductCreated = (product) => {
    viewRef.current?.refresh();
    if (product) viewRef.current?.openCard(product);
  };

  return (
    <Layout title="Products">
      {canCreate && <AddUrlComponent onProductCreated={handleProductCreated} />}
      <ProductListBC ref={viewRef} />
    </Layout>
  );
}

function AnalyticsPage() {
  return (
    <Layout title="Analytics">
      <AnalyticsDashboard />
    </Layout>
  );
}

function UsersManagementPage() {
  return (
    <Layout title="Users">
      <UsersPage />
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><Layout title="Home"><DashboardPage /></Layout></PrivateRoute>} />
          <Route path="/products" element={<PrivateRoute><ProductsPage /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><Layout title="Reports"><ReportsPage /></Layout></PrivateRoute>} />
          <Route path="/settings/retailers" element={<PrivateRoute><Layout title="Retailers"><RetailersPage /></Layout></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><UsersManagementPage /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
